import React from 'react'
import { RelatedContent } from './RelatedContent'
import { ContentDataDefinitionLoader } from 'common/data/loader-definitions'
import { createRegisterableComponentWithData } from 'common/routing/page-definition'
import { isPublicationCardItem } from 'common/client-data-types/card-types'

export interface Props {
    title?: string
}

export const RelatedContentRegistration = createRegisterableComponentWithData(
    'related-content',
    ContentDataDefinitionLoader,
    ({ title }: Props, data, services) => {
        if (data.loaded) {
            const publications = data.result.publications.filter(isPublicationCardItem)
            if (publications.length) {
                return (
                    <RelatedContent items={publications} title={title} onEvent={services.onEvent} />
                )
            }
        }

        return null
    }
)
